export default __webpack_public_path__ + "static/media/penarikan.b8952170.svg";